import { render } from "./CatalogueContentForm.vue?vue&type=template&id=20fcfad7"
import script from "./CatalogueContentForm.vue?vue&type=script&lang=js"
export * from "./CatalogueContentForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__